import { useState, useEffect, useCallback } from "react";
import { useFetch } from "../../../common/hooks/useFetch.js";
import { countMaintenancesService } from "../services/countMaintenances.service.js";

export const useCountMaintenancesQuery = (filters = {}) => {
  const fetchData = useFetch();
  const [countMaintenances, setCountMaintenances] = useState({
    countSchedulePreventiveMaintenance: 0,
    countCorrectiveMaintenance: 0,
    countPreventiveMaintenancePerformed: 0,
    countPlates: 0,
  });
  const [refreshKey, setRefreshKey] = useState(0);

  const refreshCount = useCallback(() => {
    setRefreshKey((prev) => prev + 1);
  }, []);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const response = await countMaintenancesService(fetchData)(filters);
        setCountMaintenances(response);
      } catch (error) {
        console.log(error);
      }
    };

    fetchCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.startDate, filters.endDate, refreshKey]);

  return { countMaintenances, refreshCount };
};
